<template>
  <b-row>
    <b-col cols="12" class="container-fluid">
      <b-card>
        <b-row>
          <b-col cols="12" md="12">
            <b-form-group label="RefreshToken" label-for="RefreshToken">
              <b-form-input id="refreshToken" v-model="manageData.refreshToken" placeholder="กรุณากรอก รายละเอียด" />
            </b-form-group>
          </b-col>
          <b-col cols="12" md="12">
            <b-form-group label="AccessToken" label-for="AccessToken">
              <b-form-input id="accessToken" v-model="manageData.accessToken" placeholder="กรุณากรอก รายละเอียด" />
            </b-form-group>
          </b-col>
          <b-col cols="6" md="6">
            <b-form-group label="RefreshTokenExpired" label-for="RefreshTokenExpired">
              <b-form-input id="refreshTokenExpired" v-model="DateData.refreshTokenExpiredstr" placeholder="" readonly />
            </b-form-group>
          </b-col>
          <b-col cols="6" md="6">
            <b-form-group label="AccessTokenExpired" label-for="AccessTokenExpired">
              <b-form-input id="accessTokenExpired" v-model="DateData.accessTokenExpiredstr" placeholder="" readonly />
            </b-form-group>
          </b-col>
        </b-row>
        <b-col cols="12" class="d-flex justify-content-between">
          <b-button variant="secondary" @click="onCancelBtnClicked">
            ยกเลิก
          </b-button>
          <b-button variant="primary" @click="onSubmitBtnClicked">
            บันทึกข้อมูล
          </b-button>
        </b-col>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import {
  BRow,
  BCol,
  BFormTextarea,
  BCard,
  BFormRadio,
  BTab,
  BTabs,
  BButton,
  BFormInput,
  BFormGroup,
  BFormRadioGroup,
} from "bootstrap-vue";
import * as storeMaster from "@/store/api/master/index.js";
import vSelect from "vue-select";

export default {
  components: {
    BButton,
    BFormRadio,
    BCard,
    BRow,
    BCol,
    BFormTextarea,
    BTab,
    BTabs,
    BFormInput,
    BFormGroup,
    BFormRadioGroup,
    vSelect,
  },
  props: {
    routeName: String,
  },
  data() {
    return {
      manageData: {
        id: "",
        accessToken: "",
        refreshToken: "",
      },
      DateData: {
        accessTokenExpired: "",
        refreshTokenExpired: "",
      },
    };
  },
  created() {
    const _this = this;

    this.redirectBackName = "WebexToken";

    storeMaster
        .GetWebexToken()
        .then(function(response) {
          console.log("data", response.data.data);
          _this.manageData.id = response.data.data.id;
          _this.manageData.accessToken = response.data.data.accessToken;
          _this.manageData.refreshToken = response.data.data.refreshToken;
          _this.DateData.accessTokenExpiredstr = response.data.data.accessTokenExpiredstr;
          _this.DateData.refreshTokenExpiredstr =  response.data.data.refreshTokenExpiredstr;
          console.log("manageData:", _this.manageData);
          console.log("DateData:", _this.DateData);
        })
        .catch(function(error) {
          // handle error
          console.log("error", error);
        })
        .then(function() {
          // always executed
          //console.log('GET')
        });
  },
  methods: {
    onSubmitBtnClicked() {
      const _this = this;
      //บังคับให้เลือก type = 5
      console.log("manageData:", _this.manageData);

      if (_this.manageData.refreshToken && _this.manageData.accessToken) {
        this.$swal({
          title: "ยืนยันการบันทึกข้อมูล?",
          text: "",
          icon: "success",
          showCancelButton: true,
          confirmButtonText: "บันทึก",
          cancelButtonText: "ยกเลิก",
          customClass: {
            confirmButton: "btn btn-primary",
            cancelButton: "btn btn-outline-primary ml-1",
          },
          buttonsStyling: false,
        }).then((result) => {
          if (result.value) {
            storeMaster
              .UpdateToken(_this.manageData)
              .then((response) => {
                if (response.data.success === true) {
                  _this.$bvToast.toast("บันทึกข้อมูลสำเร็จ", {
                    title: `ระบบได้บันทึกการแก้ไขของท่านแล้ว`,
                    variant: "success",
                    solid: false,
                  });

                  window.open(
                    _this.$router.resolve({
                      name: this.redirectBackName,
                    }).href,
                    "_self"
                  );
                } else {
                  _this.$bvToast.toast("เกิดข้อผิดพลาด", {
                    title: `เกิดข้อผิดพลาดในการบันทึกข้อมูล`,
                    variant: "danger",
                    solid: false,
                  });
                }
              })
              .catch((error) => {
                console.log("error", error);
                _this.$bvToast.toast("เกิดข้อผิดพลาด", {
                  title: `เกิดข้อผิดพลาดในการบันทึกข้อมูล`,
                  variant: "danger",
                  solid: false,
                });
              });
          }
        });
      } else {
        alert("โปรดระบุหมวดหมู่เรื่องร้องทุกข์ และชื่อรายละเอียด");
      }
    },
    onCancelBtnClicked() {
      window.open(
        this.$router.resolve({ name: this.redirectBackName }).href,
        "_self"
      );
    },
  },
};
</script>

<style lang="scss"></style>
